import React, { useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { FAQS, NOT_NEEDED } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-12 sm:py-16" data-id="element-44" data-mp="1bmvcovcc04q6">
      <div className="mx-auto max-w-2xl px-5" data-id="element-45" data-mp="1gkepdqtds9g0">
        <h2 className="text-center font-display text-[1.5rem] font-extrabold tracking-tight text-charcoal sm:text-[2.1rem]" data-id="element-46" data-mp="2496ci3s461lx">
          Preguntas frecuentes
        </h2>

        <ul className="mt-5 flex flex-wrap justify-center gap-1.5" data-id="element-47" data-mp="289zz8tttlad8">
          {NOT_NEEDED.map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-full bg-white px-2.5 py-1 font-sans text-[0.74rem] font-medium text-taupe" data-id="element-48" data-mp="1uhae0rm489h6">
              <XIcon className="h-3 w-3 text-gold" aria-hidden strokeWidth={3} data-id="element-49" data-mp="2n5z5dyxdd0fq" />
              {item}
            </li>)}
        </ul>

        <div className="mt-6 space-y-2" data-id="element-50" data-mp="14usib8xd8wy5">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-stone bg-white shadow-[0_10px_30px_-26px_rgba(56,37,34,0.5)]" data-id="element-51" data-mp="10v9xse9ginvu" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-52" data-mp="19tllo8ixv7kl">
                  <span className="font-display text-[0.9rem] font-semibold leading-snug text-charcoal sm:text-[0.98rem]" data-id="element-53" data-mp="1xjfw6jfsck1o">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden strokeWidth={3} data-id="element-54" data-mp="36zt1riadm11" />
                </button>
                <AnimatePresence initial={false} data-id="element-55" data-mp="238pweul0uml9">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="2867ufpxi3heh">
                      <p className="px-5 pb-4 font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-57" data-mp="2qxs9dp4pnr9f">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}